import { render } from "./registerViewComponent.vue?vue&type=template&id=681a7a37"
import script from "./registerViewComponent.vue?vue&type=script&lang=js"
export * from "./registerViewComponent.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__